import {
  EmbedVideoBlockSchema,
  type EmbedVideoModel,
  EmbedVideoStyles,
} from '@blocksuite/affine-model';
import {
  EmbedOptionConfig,
  LinkPreviewServiceIdentifier,
} from '@blocksuite/affine-shared/services';
import { BlockService } from '@blocksuite/std';

import { videoUrlRegex } from './embed-video-model.js';
import { queryEmbedVideoData } from './utils.js';

export class EmbedVideoBlockService extends BlockService {
  static override readonly flavour = EmbedVideoBlockSchema.model.flavour;

  queryUrlData = (embedVideoModel: EmbedVideoModel, signal?: AbortSignal) => {
    return queryEmbedVideoData(
      embedVideoModel,
      this.std.get(LinkPreviewServiceIdentifier),
      signal
    );
  };
}

export const EmbedVideoBlockOptionConfig = EmbedOptionConfig({
  flavour: EmbedVideoBlockSchema.model.flavour,
  urlRegex: videoUrlRegex,
  styles: EmbedVideoStyles,
  viewType: 'embed',
});
